import { _sharedReducerToc, _sharedStateToc } from "@/shared/store/toc/reducer";

export const initialState = _sharedStateToc;

const tocReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return _sharedReducerToc(state, action);
  }
};

export default tocReducer;
